__turbopack_context__.v({
  "icon": "Icon-module__DNOlPq__icon",
  "iconDefinitions": "Icon-module__DNOlPq__iconDefinitions",
  "logo": "Icon-module__DNOlPq__logo",
});
